import { render, staticRenderFns } from "./MealsTypeInfo.vue?vue&type=template&id=66462057&scoped=true&"
import script from "./MealsTypeInfo.vue?vue&type=script&lang=js&"
export * from "./MealsTypeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66462057",
  null
  
)

export default component.exports